import { render } from "./OverviewPanel.vue?vue&type=template&id=88cefd34&scoped=true"
import script from "./OverviewPanel.vue?vue&type=script&lang=js"
export * from "./OverviewPanel.vue?vue&type=script&lang=js"

import "./OverviewPanel.vue?vue&type=style&index=0&id=88cefd34&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88cefd34"]])

export default __exports__